import { useEffect, useState } from "react";
import {
  getPinnedTicketsState,
  subscribePinnedTickets,
} from "../lib/pinnedTickets";

/**
 * React-friendly view onto the pinned tickets store. Re-renders any
 * component that consumes it whenever a ticket is pinned, unpinned, moved
 * or minimized — across the entire app.
 */
export function usePinnedTickets() {
  const [state, setState] = useState(getPinnedTicketsState());
  useEffect(() => {
    const unsub = subscribePinnedTickets(setState);
    return unsub;
  }, []);
  return state;
}
